import React from 'react';
import {
    Step,
    Stepper,
    StepLabel,
} from 'material-ui/Stepper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CardDesign from '../carddesign/carddesign.jsx'
import InputMask from 'react-input-mask';
import '../../stylesheet/activate.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router-dom'
import '../../stylesheet/virtualkeyboard.css'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../actions/actions.jsx'
import services from '../../services/allservices.jsx'
import Recaptcha from 'react-recaptcha'
import KeyboardedInput from 'react-touch-screen-keyboard';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import LoaderSmall from "../loader/loadersmall.jsx"
import $ from 'jquery'
/**
 * Vertical steppers are designed for narrow screen sizes. They are ideal for mobile.
 *
 * To use the vertical stepper with the contained content as seen in spec examples,
 * you must use the `<StepContent>` component inside the `<Step>`.
 *
 * <small>(The vertical stepper can also be used without `<StepContent>` to display a basic stepper.)</small>
 */


const styles = {
    stepbutton: {
        fill: "rgb(48, 86, 151)"
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
}

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        cardNumber: state.stoteCardDetail.cardNumber,
        secretQues: state.secretQuesReducer.secretQues,
        quesReceived: state.secretQuesReducer.quesReceived,
        validUserIdState: state.getValidIdReducer.validUserIdState,
        activationcardState: state.getactivationcardReducer.activationcardState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        fetchSecretQues(quesReceived) {
            dispatch(
                actions.secretQuesAction(quesReceived)
            )
        },
        validateUserId(username) {
           
            dispatch(
                actions.validateUserIdAction(username)
            )
        },
        getactivation(state) {
            
            dispatch(
                actions.getactivationcardAction(state)

            )
        },
    })

var callback = function () {

};

// specifying verify callback function
var verifyCallback = function (response) {

};
const JSEncrypt = window.JSEncrypt
class Activate extends React.Component {

    constructor(props) {
        super(props);
        this.handleActivate = this.handleActivate.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleUserInfo = this.handleUserInfo.bind(this)
        this.handleVerify = this.handleVerify.bind(this)
        this.findDescription = this.findDescription.bind(this)
        this.handleActiveUser = this.handleActiveUser.bind(this)
        this.validusernameresp = this.validusernameresp.bind(this)
    }

    state = {
        response: "",
        activatedCardNumber: "",
        activatedFirstName: "",
        activatedLastName: "",
        activatedExpDate: "",
        stepIndex: JSON.parse(localStorage.getItem("step")),
        pin: "",
        confirmPin: "",
        correctUsername: true,
        correctPassword: true,
        customMapping: [
        ],
        expiry: "",
        confirmPinError: false,

        pinError: false,
        expiryError: false,
        openWrongPinSnac: false,
        value: "", secretPassword: "", userName: "", password: "", email: "", confirmPassword: "",
        usernameVerified: false,
        // value: 1
    };

    handleCapcha(value) {
        this.setState({
            capcha: value
        })
    }
    handleSelect = (event, index, value) => {
        this.findDescription(value)
        this.setState({ value })
    };
    findDescription(value) {
        const { secretQues } = this.props
        for (let i = 0; i < secretQues.body.length; i++) {
            if (secretQues.body[i].secretQuestionCode === value) {
                this.setState({ description: secretQues.body[i].description })
            }
        }
    }
    componentDidMount() {

        const { stepIndex } = this.state
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") == "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });

        if (stepIndex === 0) {
            document.getElementById('cofirmpin').onkeypress = function () { return false; }
            document.getElementById('pin').onkeypress = function () { return false; }
        }
        this.props.fetchPublicKey(false)
        this.props.fetchSecretQues(false)

    }
    removepwd = () => {
        this.setState({
            correctpawd: true
        })
    }
    removeemail = () => {
        this.setState({
            correctEmail: true
        })
    }
    onChange(e, value) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    handleValueChange(val) {
        if (val.length <= 4) {
            this.setState({ pin: val });
        }
    }
    handleValueChangeconfirm(val) {
        if (val.length <= 4) {
            this.setState({ confirmPin: val });
        }
    }
    handleValueChangenext(val) {
        if (val.length <= 4) {
            this.setState({ pin: val });
        }
    }
    handleValueChangeconfirmnext(val) {
        if (val.length <= 4) {
            this.setState({ confirmPin: val });
        }
    }


    validusernameresp = () => {
        //    const {validUserIdState} = this.props
        let validstate1 = localStorage.getItem("validUserId")

        let validState = JSON.parse(validstate1)
        if (validState.body.userIdAvailable === false) {
            this.setState({
                usernameVerified: false
            }, () => {
                document.getElementById("valid1").style.display = "none"
                document.getElementById("invalid1").style.display = "block"
                document.getElementById("myModal").style.display = "block"


            })
        }
        else {
            this.setState({
                usernameVerified: false
            }, () => {
                document.getElementById("invalid1").style.display = "none"
                document.getElementById("valid1").style.display = "block"


            })
        }

    }
    handleClose = () => {      
        if (document.getElementById("username") !== null) {

            document.getElementById("username").value = ""
            document.getElementById("username").focus()
        }
        document.getElementById("invalid1").style.display = "none"
        document.getElementById("myModal").style.display = "none"


    }

    checkUserName = (e, value) => {
        let _this = this
        if (e.target.name === "userName") {
            if ((e.target.value.length) >= 6) {
                this.props.validateUserId(_this.state.userName)
                this.setState({
                    usernameVerified: true,
                    userName: value || _this.state.userName
                })

                setTimeout(function () {
                    _this.validusernameresp()
                }, 1000)

            }

            else {
                this.setState({
                    correctUsername: false
                })
            }
        }


    }



    handelvalidateusername = (e, value) => {
        let _this = this
        if (e.target.name === "userName") {
            $(function () {
                $('#username').on('keypress', function (e) {
                    if (e.which === 32)
                        return false;
                });
            });
            if ((e.target.value.length) >= 6) {
               
                this.setState({
                    userName: value || this.state.userName,
                    correctUsername: true
                }, () => {
                    document.getElementById("valid1").style.display = "none"
                    document.getElementById("invalid1").style.display = "none"
                })
            } else {
                this.setState({
                    correctUsername: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            }, () => {


            })
        }
    }
    verifyCallback = response => {
       
        this.setState({
            response: response
        })
    }
    getStepContent(stepIndex) {
        let userInfo = localStorage.getItem("updateSecurityInfo")
        const statusInfo = localStorage.getItem('status')
        if (statusInfo === "A" || userInfo === "Y") {
            switch (stepIndex) {
                case 0:
                    const { pinError, confirmPinError, expiryError, correctpawd, correctEmail } = this.state;
                    const msg = "This Field is Required"
                    const errorDiv = <div className="offset-md-2 col-sm-12 " style={{ marginTop: -20, color: "#d64a4a", fontSize: "13px" }}>
                        {msg}
                    </div>
                    return (
                        <div className="row">

                            <div className="col-md-12" style={{ marginTop: "20px" }}>
                                <h4>Personal Indentification Number</h4>
                                <p>
                                    Please choose your personal identification number (PIN). You will need to enter this PIN when prompted by the merchant when using your card. You can change your PIN at any time by clicking on Change PIN from the Profile Page once you have logged into your account. Enter a 4 digit number.
                                    </p>
                            </div>
                            <div className=" col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 activatefirstinput" >
                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10 " >
                                        <div className="group" id="pin" >

                                            <KeyboardedInput
                                                type={"password"}
                                                enabled
                                                value={this.state.pin}
                                                onChange={(value) => { this.handleValueChange(value); }}
                                                name={"pin"}
                                                opacity={1}
                                                defaultKeyboard={this.state.customMapping}
                                                placeholder="Enter 4 Digit"
                                                step={4}
                                                isDraggable={false}
                                                style={{ backgroundColor: "rgb(245, 248, 252)" }}
                                            />
                                        </div>
                                    </div>
                                    {pinError && errorDiv}
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 activatefirstinput" >
                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10 " >
                                        <div className="group" id="cofirmpin" >
                                            <KeyboardedInput
                                                type={"password"}
                                                enabled
                                                value={this.state.confirmPin}
                                                onChange={(value) => { this.handleValueChangeconfirm(value); }}
                                                name={"confirmPin"}
                                                opacity={1}
                                                defaultKeyboard={this.state.customMapping}
                                                placeholder={'Confirm Your Pin'}
                                                step={4}
                                                isDraggable={false}
                                                style={{ backgroundColor: "rgb(245, 248, 252)" }} />
                                        </div>
                                    </div>
                                    {confirmPinError && errorDiv}
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row input-group">
                                    <div className="col-sm-2 activatefirstinput">
                                        <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                                    </div>
                                    <div className="col-sm-10">
                                        <div className="group">
                                            <InputMask mask="99/99" placeholder="MM/YY" name="expiry" onChange={this.onChange.bind(this)} />
                                            <span className="highlight"></span>
                                            <span className="bar"></span>
                                            <label>Expiration Date</label>
                                        </div>
                                    </div>
                                    {expiryError && errorDiv}
                                </div>

                            </div>
                            {/* <div className="col-md-4 nopaddingright">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Typing"
                                                floatingLabelText="Expiration Date"
                                                name="password"
                                                type="password"
                                                className="input-width"
                                                onChange={this.onChange}
                                            />
                                        </div>
                                    </div>
                                </div> */}
                        </div>
                    );

                case 1:
                    const { secretQues } = this.props
                    const { correctUsername, usernameVerified, confirmPassword, correctPassword } = this.state
                    return (
                        <div className="row">
                            <div className="col-md-12" style={{ marginTop: "20px" }}>
                                <h4>Secure Login Detail</h4>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 activatesecondinput" >
                                        <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-9" style={{ paddingRight: "0px" }}>

                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="User ID"
                                            type="text"
                                            name="userName"
                                            maxLength="50"
                                            minLength="6"
                                            className="input-width"
                                            id="username"
                                            autoFocus={this.state.autoFocus}
                                            defaultValue={this.state.userName || null}
                                            onChange={this.handelvalidateusername}
                                            onBlur={this.checkUserName}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                            errorText={correctUsername ? null : "Must contain minimum 6"}
                                        // errorText="This field is required"
                                        />

                                    </div>
                                    <div className="col-sm-1" style={{ padding: "0px" }}>
                                        {usernameVerified ? <LoaderSmall /> : null}
                                        <div className="col-sm-12" id="valid1" style={{ display: "none", marginTop: "35px" }}>
                                            <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i>
                                        </div>
                                        <div className="col-sm-12" id="invalid1" style={{ display: "none", marginTop: "35px" }}>
                                            <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 activatesecondinput" >
                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-9" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Password"
                                            name="password"
                                            type="password"
                                            maxLength="15"
                                            className="input-width"
                                            defaultValue={this.state.password || null}
                                            onChange={this.handelepassword}
                                            underlineFocusStyle={styles.focusStyle}

                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                            errorText={correctPassword ? null : "Please check help button"}
                                        />
                                    </div>
                                    <div className="col-sm-1 tooltip nopadding" style={{ top: "35px", right: "0px" }}>
                                        <i className="fa fa-question-circle" aria-hidden="true"></i>
                                        <span className="tooltiptext" style={{ fontSize: "12px" }} >Your Password must contain at least 8 characters including one number, one lowercase letter, one uppercase letter and a special character. As an example, Rainbow123!</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Confirm Password"
                                            name="confirmPassword"
                                            type="password"
                                            defaultValue={this.state.confirmPassword || null}
                                            maxLength="15"
                                            className="input-width"
                                            onChange={this.onChange}

                                            underlineFocusStyle={styles.focusStyle}
                                            onFocus={this.removematchpwd}
                                            floatingLabelFocusStyle={styles.focusTextStyle}


                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-question-circle text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10">
                                        <SelectField
                                            value={this.state.value}
                                            onChange={this.handleSelect}
                                            floatingLabelText="Secret Question"
                                            className="input-width"
                                        >
                                            {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                <MenuItem value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                            ) : <div></div>}
                                        </SelectField>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-exclamation-circle text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10" >
                                        <TextField
                                            hintText="Typing"
                                            defaultValue={this.state.secretPassword || null}
                                            floatingLabelText="Secret Answer"
                                            name="secretPassword"
                                            type="type"
                                            className="input-width"
                                            maxLength="50"
                                            onChange={this.onChange}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-envelope text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Email"
                                            name="email"
                                            type="text"
                                            className="input-width"
                                            defaultValue={this.state.email || null}
                                            maxLength="50"
                                            onChange={this.onChange}
                                            defaultValue={this.state.email}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="required" style={{ fontSize: "11px", marginTop: "20px", marginLeft: "18px" }}><b>Note:</b><label>All fields are mandatory</label></div>
                        </div >
                    );

                case 2:
                    const { secretPassword, userName, email, description, activatedCardNumber, activatedFirstName, activatedExpDate, activatedLastName } = this.state
                    return (
                        <div className="tile box-shadow-style" style={{ marginTop: "20px" }}>
                            <div className="row">

                                <div className="col-md-6 col-sm-12">
                                    <div className="row">
                                        <div className="offset-md-1 col-md-3 tilepadding">
                                            <label className="tilecontent">User ID </label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername">   {userName} </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-1 col-md-3 tilepadding">
                                            <label className="tilecontent">E-Mail </label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername"> {email}</span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-1 col-md-3 tilepadding">
                                            <label className="tilecontent">Secret Question </label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername"> {description} </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-1 col-md-3 tilepadding">
                                            <label className="tilecontent">Secret Answer </label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername"> {secretPassword} </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 text-center margin-capcha">
                                            <Recaptcha
                                                sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                render="explicit"
                                                verifyCallback={this.verifyCallback}
                                                onloadCallback={callback}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="offset-md-1 col-md-4">
                                    <CardDesign name={activatedFirstName + " " + activatedLastName} cardno={activatedCardNumber} balance={activatedExpDate} startwith="4813" />
                                </div>
                            </div>
                        </div>
                    );
                default:
                    return (
                        <div>Something Went Wrong</div>
                    )
            }
        } else if (statusInfo === "A" && userInfo === "N") {
            switch (stepIndex) {
                case 0:
                    const { pinError, confirmPinError, expiryError } = this.state;
                    const msg = "This Field is Required"
                    const errorDiv = <div className="offset-md-2 col-sm-12 " style={{ marginTop: -20, color: "#d64a4a", fontSize: "13px" }}>
                        {msg}
                    </div>
                    return (
                        <div className="row">
                            <div className="col-md-12" style={{ marginTop: "20px" }}>
                                <h4>Personal Indentification Number</h4>
                                <p>
                                    Please choose your personal identification number(PIN). You will need to enter this PIN when prompted by the merchant when using your card. You can change your PIN at any time by clicking on Change PIN from the Profile Page once you have logged into your account. Enter a 4 digit number.
                                    </p>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10 " >
                                        <div className="group" id="pin" >
                                            <KeyboardedInput
                                                type={"password"}
                                                enabled
                                                value={this.state.pin}
                                                onChange={(value) => { this.handleValueChangenext(value); }}
                                                name={"pin"}
                                                opacity={1}
                                                defaultKeyboard={this.state.customMapping}
                                                placeholder="Enter 4 Digit"
                                                step={4}
                                                isDraggable={false}

                                            />

                                        </div>

                                    </div>
                                    {pinError && errorDiv}
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10" >
                                        <div className="group" id="cofirmpin" >
                                            <KeyboardedInput
                                                type={"password"}
                                                enabled
                                                value={this.state.confirmPin}
                                                onChange={(value) => { this.handleValueChangeconfirmnext(value); }}
                                                name={"confirmPin"}
                                                opacity={1}
                                                defaultKeyboard={this.state.customMapping}
                                                placeholder={'Confirm Your Pin'}
                                                step={4}
                                                isDraggable={false}

                                            />
                                        </div>
                                    </div>
                                    <div id="errormsgcommunitylength">
                                        community Should have at least 5 member.
                                                                    </div>
                                    {confirmPinError && errorDiv}
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="row input-group">
                                    <div className="col-sm-2 input-icon">
                                        <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                                    </div>
                                    <div className="col-sm-10">
                                        <div className="group">
                                            <InputMask mask="99/99" placeholder="12/18" name="expiry" onChange={this.onChange.bind(this)} />
                                            <span className="highlight"></span>
                                            <span className="bar"></span>
                                            <label>Expiration Date</label>
                                        </div>
                                    </div>
                                    {expiryError && errorDiv}
                                </div>

                            </div>
                            {/* <div className="col-md-4 nopaddingright">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Typing"
                                                floatingLabelText="Expiration Date"
                                                name="password"
                                                type="password"
                                                className="input-width"
                                                onChange={this.onChange}
                                            />
                                        </div>
                                    </div>
                                </div> */}
                        </div>
                    );
                default:
                    return (
                        <div>Something Went wrong</div>
                    )
            }
        }
        else {
            switch (stepIndex) {
                case 1:
                    const { secretQues } = this.props
                    const { correctUsername, usernameVerified, correctPassword, firstName, lastName, cardNumber, expDate } = this.state
                    return (
                        <div className="row">
                            <div className="col-md-12" style={{ marginTop: "20px" }}>
                                <h4>Secure Login Detail</h4>

                            </div>

                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 activatesecondinput" >
                                        <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-9" style={{ paddingRight: "0px" }}>

                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="User ID"
                                            type="text"
                                            name="userName"
                                            id="username"
                                            maxLength="50"
                                            minLength="6"
                                            defaultValue={this.state.userName || null}
                                            className="input-width"
                                            onChange={this.handelvalidateusername}
                                            onBlur={this.checkUserName}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                            errorText={correctUsername ? null : "Must contain minimum 6"}
                                        // errorText="This field is required"
                                        />

                                    </div>
                                    <div className="col-sm-1" style={{ padding: "0px" }}>
                                        {usernameVerified ? <LoaderSmall /> : null}
                                        <div className="col-sm-12" id="valid1" style={{ display: "none", marginTop: "35px" }}>
                                            <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i>
                                        </div>
                                        <div className="col-sm-12" id="invalid1" style={{ display: "none", marginTop: "35px" }}>
                                            <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2  activatesecondinput" >
                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-9" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Password"
                                            name="password"
                                            type="password"
                                            maxLength="15"
                                            className="input-width"
                                            onChange={this.handelepassword}
                                            underlineFocusStyle={styles.focusStyle}
                                            defaultValue={this.state.password || null}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                            errorText={correctPassword ? null : "Please check help button"}
                                        />
                                    </div>
                                    <div className="col-sm-1 tooltip nopadding" style={{ top: "35px", right: "0px" }}>
                                        <i className="fa fa-question-circle" aria-hidden="true"></i>
                                        <span className="tooltiptext" style={{ fontSize: "12px" }} >Your Password must contain at least 8 characters including one number, one lowercase letter, one uppercase letter and a special character. As an example, Rainbow123!</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-9" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Confirm Password"
                                            name="confirmPassword"
                                            type="password"
                                            maxLength="15"
                                            id="loginpassword"
                                            className="input-width"
                                            defaultValue={this.state.confirmPassword || null}
                                            onChange={this.onChange}
                                            underlineFocusStyle={styles.focusStyle}
                                            onFocus={this.removematchpwd}
                                            floatingLabelFocusStyle={styles.focusTextStyle}


                                        />
                                    </div>
                                    <div className="col-sm-1 nopadding">
                                        <span toggle="#loginpassword" className="fa fa-fw fa-eye field-icon toggle-password" style={{ position: "relative", color: "#333", top: "35px" }}></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-question-circle text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10">
                                        <SelectField
                                            value={this.state.value}
                                            onChange={this.handleSelect}
                                            floatingLabelText="Secret Question"
                                            className="input-width"
                                        >
                                            {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                <MenuItem value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                            ) : <div></div>}
                                        </SelectField>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-exclamation-circle text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-10" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Secret Answer"
                                            name="secretPassword"
                                            type="type"
                                            className="input-width"
                                            maxLength="50"
                                            onChange={this.onChange}
                                            defaultValue={this.state.secretPassword || null}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 nopaddingright">
                                <div className="row input-group" >
                                    <div className="col-sm-2 input-icon" >
                                        <i className="fa fa-envelope text-dark " aria-hidden="true"></i>
                                    </div>
                                    <div className="col-sm-9" >
                                        <TextField
                                            hintText="Typing"
                                            floatingLabelText="Email"
                                            name="email"
                                            type="text"
                                            className="input-width"
                                            maxLength="50"
                                            defaultValue={this.state.email || null}
                                            onChange={this.onChange}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="required" style={{ fontSize: "11px", marginTop: "20px", marginLeft: "18px" }}><b>Note:</b><label>All fields are mandatory</label></div>
                        </div >

                    );

                case 2:
                    const { secretPassword, userName, email, description, activatedCardNumber, activatedFirstName, activatedExpDate, activatedLastName } = this.state
                    const { activationcardState } = this.props
                    
                    return (
                        <div className="tile box-shadow-style" style={{ marginTop: "20px" }}>
                            <div className="row">

                                <div className="col-md-6 col-sm-12">
                                    <div className="row">
                                        <div className="offset-md-1 col-md-3 tilepadding">
                                            <label className="tilecontent">User ID </label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername">   {userName} </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-1 col-md-3 tilepadding">
                                            <label className="tilecontent">E-Mail </label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername"> {email}</span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-1 col-md-3 tilepadding">
                                            <label className="tilecontent">Secret Question </label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername"> {description} </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-1 col-md-3 tilepadding">
                                            <label className="tilecontent">Secret Answer </label>
                                        </div>
                                        <div className="col-md-6 text-left tilepadding">
                                            <span className="tileheadername"> {secretPassword} </span><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 text-center margin-capcha">
                                            <Recaptcha
                                                sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                render="explicit"
                                                verifyCallback={this.verifyCallback}
                                                onloadCallback={callback}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="offset-md-1 col-md-4">
                                    <CardDesign name={activationcardState.firstName + " " + activationcardState.lastName} cardno={activationcardState.cardNumber} balance={activationcardState.expiryDate} startwith="4813" />
                                </div>
                            </div>


                        </div>

                    );
                default:
                    return (
                        <div>Something Went Wrong</div>
                    )
            }

        }
    }
    handleActivate() {
        const { publicKey } = this.props
        const { expiry, pin, confirmPin } = this.state;
        let userInfo1 = localStorage.getItem('updateSecurityInfo')
        let statusInfo1 = localStorage.getItem('status')
        let expiryDate = expiry.replace("/", "");
        if (expiry === "") {
            this.setState({ expiryError: true })
        } else {
            this.setState({ expiryError: false })
        }
        if (pin === "") {
            this.setState({ pinError: true })
        } else {
            this.setState({ pinError: false })
        }
        if (confirmPin === "") {
            this.setState({ confirmPinError: true })
        } else {
            this.setState({ confirmPinError: false })
        }
        // this.setState({ stepIndex: 1 })
        let _this = this
        if (pin !== "" && confirmPin !== "" && expiry !== "") {
            if (pin.length == 4) {
                if (confirmPin.length == 4) {
                    if (pin === confirmPin) {
                        if (publicKey.status === 200) {
                            const public_Key = publicKey.body.publickey;
                            let encrypt = new JSEncrypt();
                            encrypt.setPublicKey(public_Key);
                            const state = {
                                expDate: encrypt.encrypt(expiryDate),
                                cardNumber: localStorage.getItem("cardNumber"),
                                pin: encrypt.encrypt(this.state.pin),
                                applicationId: "gmcabs",
                                updateSecurityInfo: userInfo1
                            }
                            this.setState({
                                loader: true
                            })
                            if (statusInfo1 == "A" && userInfo1 == "Y") {

                                fetch(services.activate_card, {
                                    method: 'POST',
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                    }),
                                    body: JSON.stringify(state)
                                })
                                    .then(response => {
                                        if (response.status === 200 || response.status === 201) {

                                            toast.success(response.headers.get('message'), {
                                                position: "top-right",
                                                draggablePercent: 60,
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: false
                                            });
                                            this.setState({
                                                loader: false
                                            })

                                            response.json().then(function (object) {
                                                _this.setState({
                                                    activatedCardNumber: object.cardNumber,
                                                    activatedExpDate: object.expDate,
                                                    activatedFirstName: object.firstName,
                                                    activatedLastName: object.lastName
                                                })

                                                localStorage.setItem("accountId", object.accountId)

                                                _this.setState({ stepIndex: 1 })

                                            })

                                        } else {
                                            this.setState({
                                                loader: false
                                            })
                                            toast.error(response.headers.get('message'), {
                                                position: "top-right",
                                                autoClose: 5000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true
                                            });
                                        }
                                    })

                            }

                            else {

                                fetch(services.activate_card, {
                                    method: 'POST',
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                    }),
                                    body: JSON.stringify(state)
                                })
                                    .then(response => {
                                        if (response.status === 200 || response.status === 201) {


                                            this.setState({
                                                loader: false
                                            })

                                            response.json().then(function (json) {
                                                let exp = json.expiryInMinutes
                                               
                                                let expiry = (exp * 60000 + new Date().getTime())
                                                
                                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                                localStorage.setItem("loginState", true)
                                                localStorage.setItem('memberId', json.memberId);
                                                localStorage.setItem('token', json.token)
                                                localStorage.setItem('accountId', json.accountId);
                                               
                                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                                toast.success(response.headers.get('message'), {
                                                    position: "top-right",
                                                    draggablePercent: 60,
                                                    autoClose: 3000,
                                                    hideProgressBar: false,
                                                    closeOnClick: true,
                                                    pauseOnHover: true,
                                                    draggable: false
                                                });
                                                setTimeout(function () {
                                                    _this.props.history.push("/home")
                                                }, 3000)



                                            })

                                        } else {
                                            this.setState({
                                                loader: false
                                            })
                                            toast.error(response.headers.get('message'), {
                                                position: "top-right",
                                                autoClose: 5000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true
                                            });
                                        }
                                    })

                            }






                        }
                    } else {
                        this.setState({
                            loader: false
                        })
                        toast.error("Enter and Confirm Pin Doesn't Match !", {
                            position: "top-right",
                            autoClose: true,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true
                        });
                    }
                } else {
                    this.setState({
                        loader: false
                    })
                    toast.error('Confirm PIN should be 4 digits'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };

                }
            } else {
                toast.error('New PIN should be 4 digits .'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                };

            }

        }


    }
    handleback = () => {
        this.props.history.push(this.setState({ stepIndex: 1 }))
    }
    handelepassword = (e, value) => {
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "password") {
            if (passwd.test(e.target.value)) {
                this.setState({
                    correctPassword: true,
                    password: value
                })
            } else {
                this.setState({
                    correctPassword: false
                })
            }
        }

    }
    handleVerify() {
        const { password, email, confirmPassword, response } = this.state
        const { publicKey } = this.props
        let _this = this;

        if (response !== "") {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let state = {
                    applicationId: "gmcabs",
                    secretQuestionCode: encrypt.encrypt(this.state.value),
                    accountId: encrypt.encrypt(localStorage.getItem("accountId")),
                    secretPassword: encrypt.encrypt(this.state.secretPassword),
                    userName: encrypt.encrypt(this.state.userName),
                    password: encrypt.encrypt(this.state.password),
                    emailId: encrypt.encrypt(this.state.email)
                }
                this.setState({
                    loader: false
                })

                fetch(services.update_user_info + "/?g-recaptcha-response=" + response, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            this.setState({
                                loader: false
                            })
                            response.json().then(function (object) {
                                let exp = object.expiryInMinutes
                               
                                let expiry = (exp * 60000 + new Date().getTime())
                               
                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                localStorage.setItem("loginState", true)
                                localStorage.setItem('memberId', object.memberId);
                                localStorage.setItem('token', object.token)
                                localStorage.setItem('accountId', object.accountId);
                               
                                localStorage.setItem('lastSuccessfulLogin', object.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', object.lastUnsuccessfulLogin);
                                _this.props.history.push("/home")

                            })
                        } else {
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                        }
                    })


            }
        }
    }

    handleUserInfo() {
        const { correctPassword } = this.state
        
        const { value, secretPassword, userName, password, email, confirmPassword } = this.state
       
        if (password !== "" && confirmPassword !== "" && email !== "" && userName !== "" && secretPassword !== "" && value !== "") {
            if (correctPassword === false) {
                this.setState({
                    correctPassword: false,
                })
            }
            else {
                if (password === confirmPassword) {
                    if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(email)) {
                        this.setState({ stepIndex: 2 })
                    } else {
                        toast.error('Not a valid email'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        }
                       
                    }
                } else {
                    toast.error('New Password and Confirm Password should be same'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    }
                   
                }
            }
        }
        else {
          
        }
    }

    handleActiveUser() {
        const { publicKey } = this.props
        const { expiry, pin, confirmPin } = this.state;
        let expiryDate = expiry.replace("/", "");
        if (expiry === "") {
            this.setState({ expiryError: true })
        } else {
            this.setState({ expiryError: false })
        }
        if (pin === "") {
            this.setState({ pinError: true })
        } else {
            this.setState({ pinError: false })
        }
        if (confirmPin === "") {
            this.setState({ confirmPinError: true })
        } else {
            this.setState({ confirmPinError: false })
        }
        // this.setState({ stepIndex: 1 })
        let _this = this
        if (pin !== "" && confirmPin !== "" && expiry !== "") {
            if (pin === confirmPin) {
                if (publicKey.status === 200) {
                    const public_Key = publicKey.body.publickey;
                    let encrypt = new JSEncrypt();
                    encrypt.setPublicKey(public_Key);
                    const state = {
                        expDate: encrypt.encrypt(expiryDate),
                        cardNumber: localStorage.getItem("cardNumber"),
                        pin: encrypt.encrypt(this.state.pin),
                        applicationId: "gmcabs",
                        updateSecurityInfo: "Y"
                    }
                    this.setState({
                        loader: true
                    })
                    fetch(services.activate_card, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                        }),
                        body: JSON.stringify(state)
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 201) {
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                                this.setState({
                                    loader: false
                                })

                                response.json().then(function (object) {
                                    _this.setState({
                                        activatedCardNumber: object.cardNumber,
                                        activatedExpDate: object.expDate,
                                        activatedFirstName: object.firstName,
                                        activatedLastName: object.lastName
                                    })
                                    localStorage.setItem("accountId", object.accountId)
                                    // _this.setState({ stepIndex: 1 })
                                })
                            } else {
                                this.setState({
                                    loader: false
                                })
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true
                                });
                            }
                        })
                }
            } else {
                this.setState({
                    loader: false
                })
                toast.error("Enter and Confirm Pin Doesn't Match !", {
                    position: "top-right",
                    autoClose: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            }

        }

    }
    render() {
        const userInfo = localStorage.getItem('updateSecurityInfo')
        const statusInfo = localStorage.getItem('status')
        const { stepIndex } = this.state;
        const { activationcardState } = this.props
        const height = $(window).height() - 217;

   
        return (
            <div style={{ margin: 'auto' , height: height }}>
                {statusInfo === "A" && userInfo === "Y" ?
                    <Stepper activeStep={stepIndex} >
                        <Step className="step">
                            <StepLabel>Create Your PIN</StepLabel>
                        </Step>
                        <Step className="step">
                            <StepLabel>User Information</StepLabel>
                        </Step>
                        <Step className="step">
                            <StepLabel>Verify & Submit</StepLabel>
                        </Step>
                    </Stepper>
                    :
                    (statusInfo === "A" && userInfo === "N") ?
                        <Stepper activeStep={stepIndex} >
                            <Step className="step">
                                <StepLabel>Create Your PIN</StepLabel>
                            </Step>
                        </Stepper>
                        :
                        <Stepper activeStep={stepIndex} >
                            <Step className="step">
                                <StepLabel>User Information</StepLabel>
                            </Step>
                            <Step className="step">
                                <StepLabel>Verify & Submit</StepLabel>
                            </Step>
                        </Stepper>
                }
                {this.getStepContent(stepIndex)}
 
                <div style={{ marginBottom: 12 }}>

                    {statusInfo === "A" && userInfo === "Y" ?
                        <RaisedButton
                            label={stepIndex === 0 ? 'Activate' : 'Submit'}

                            onClick={stepIndex === 0 ? this.handleActivate : stepIndex === 1 ? this.handleUserInfo : this.handleVerify}
                            style={styles.button}
                            backgroundColor="#333"
                            labelColor="#fff"
                        />
                        : (statusInfo === "A" && userInfo === "N") ?
                            <RaisedButton
                                label="Activate"
                                onClick={this.handleActivate}
                                style={styles.button}
                                backgroundColor="#333"
                                labelColor="#fff"
                            />

                            :
                            <RaisedButton
                                label={'Submit'}
                                onClick={stepIndex === 1 ? this.handleUserInfo : this.handleVerify}
                                style={styles.button}
                                backgroundColor="#333"
                                labelColor="#fff"
                            />
                    }

                </div>

                {this.state.loader === true &&
                    <div className="col-sm-1" style={{ marginTop: "-61px", marginLeft: "90px", width: "30% !mportant" }} >
                        <LoaderSmall />
                    </div>}
                {stepIndex === 2 &&
                    <div style={{ marginTop: "-49px", marginLeft: "135px" }}>
                        <RaisedButton
                            label="back"
                            onClick={this.handleback}
                            style={styles.button}
                            backgroundColor="#333"
                            labelColor="#fff"
                        />
                    </div>}

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                {/* Same as */}
                <div className="col-sm-12 modal-for-login flowmodal" id="myModal" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Error</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-times fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                <span>User Id already exists!</span>
                            </div>
                            <div className="col-sm-12" >
                                <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)" }}
                                    onClick={this.handleClose.bind(this)}
                                    aria-label="Close">
                                    OK
                           </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


Activate.propTypes = {
    keyRecieved: PropTypes.bool
};
Activate.defaultProps = {
    keyRecieved: false
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Activate));


// WEBPACK FOOTER //
// ./src/components/register/activate.jsx